var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_feather-search",
    "data-name": "Icon feather-search",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 12.179 12.179",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M8.48,3A5.48,5.48,0,1,1,4.605,4.605,5.445,5.445,0,0,1,8.48,3Zm0,9.743A4.263,4.263,0,1,0,4.218,8.48,4.267,4.267,0,0,0,8.48,12.743Z",
    transform: "translate(-3 -3)",
    fill: "#2d5794"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M26.733,27.342a.607.607,0,0,1-.431-.178l-2.649-2.649a.609.609,0,1,1,.861-.861L27.163,26.3a.609.609,0,0,1-.431,1.04Z",
    transform: "translate(-15.163 -15.163)",
    fill: "#2d5794"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.e943d1893b04e189aaddf04ba53fab12.svg";
export { ForwardRef as ReactComponent };